import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateRegisterTokenProps, sessionService } from '../../../application/SessionService';

type UseSessionRegisterResponseProps = ServiceResponse<(props: CreateRegisterTokenProps) => void, void>;

// Hooks act as 'Adapter' layer.
export const useSessionRegister = (): UseSessionRegisterResponseProps => {
  const queryClient = useQueryClient();

  const { isLoading, isSuccess, isError, mutate } = useMutation(
    (props: CreateRegisterTokenProps) => sessionService.createRegisterToken(props),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([`user_is_logged`]);
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    run: mutate,
  };
};
